import { api } from 'api/client';

export const uploadCV = (file: FormData) => {
  return api.post<string>('/assets/cv', file);
};

export const deleteCV = (link: string) =>
  api.delete(`/assets/cv/?link=${link}`);
